import type { IconName } from "@circleco/compass/components/Icon";
import { Icon } from "@circleco/compass/components/Icon";

import { t } from "@/i18n-js/instance";

export interface SegmentOption<TValue extends string> {
  icon?: IconName;
  labelKey: string;
  value: TValue;
}

export const buildOptions = <TValue extends string>(
  options: Array<SegmentOption<TValue>>,
) =>
  options.map(option => {
    const label = t(option.labelKey);

    return {
      label: option.icon ? (
        <span className="flex min-w-0 items-center justify-center px-1">
          <span className="sr-only">{label}</span>
          <Icon name={option.icon} size="md" />
        </span>
      ) : (
        label
      ),
      value: option.value,
    };
  });

export const handleSegmentChange =
  <TValue extends string>(
    options: Array<SegmentOption<TValue>>,
    onSelect: (value: TValue) => void,
  ) =>
  (value: string) => {
    const selectedValue = options.find(option => option.value === value)?.value;
    if (selectedValue) {
      onSelect(selectedValue);
    }
  };
